// packages/world-model/src/traits/exit/index.ts

export { ExitTrait } from './exitTrait';
export { ExitBehavior } from './exitBehavior';
